const LIST_PATH = "/campaigns";

export const campaignPaths = {
  list: LIST_PATH,
  detail: id => `${LIST_PATH}/${id}`,
  edit: id => `${LIST_PATH}/${id}/edit`,
  create: () => `${LIST_PATH}/new`,
};
